import { buttonVariants } from '@/components/ui/button'
import { imageUrl } from '../helpers/hooks'
import { useTranslation } from 'react-i18next'

type Props = {
  className?: string
  withLabel?: boolean
  excludeGoogle?: boolean
}

const LoginButtons = ({
  className,
  withLabel = true,
  excludeGoogle = false,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className={`flex items-center gap-1 ${className ?? ''}`}>
      {withLabel && (
        <span className='mr-2 text-sm hidden sm:block'>
          {t('header.log-in-with')}
        </span>
      )}
      <a href='/auth/bnet' className={buttonVariants({ variant: 'outline' })}>
        <img src={imageUrl('bnet-logo-blue.svg')} className='w-5 sm:mr-2' />
        <span className='hidden sm:block'>Battle.net</span>
      </a>
      {!excludeGoogle && (
        <a
          href='/auth/google_oauth2'
          className={buttonVariants({ variant: 'outline' })}
        >
          <img src={imageUrl('google-logo.svg')} className='w-5 sm:mr-2' />
          <span className='hidden sm:block'>Google</span>
        </a>
      )}
    </div>
  )
}

export default LoginButtons
